import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=3102e2aa&scoped=true"
import script from "./FriendlyLink.vue?vue&type=script&lang=js"
export * from "./FriendlyLink.vue?vue&type=script&lang=js"
import style0 from "./FriendlyLink.vue?vue&type=style&index=0&id=3102e2aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3102e2aa",
  null
  
)

export default component.exports